import { useQuery } from '@tanstack/react-query';
import { loadPortalData } from '../services/programService';

export function usePortalData() {
  return useQuery({
    queryKey: ['portal-data'],
    queryFn: loadPortalData,
  });
}
